import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadExportStatusFailed, loadExportStatusSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadExportStatus(action) {
  try {
    const url = `${BACKEND_URL}/api/export-status`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK && data && data.data) {
      yield put(loadExportStatusSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadExportStatusFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadExportStatusFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
